import React from 'react';
import './PetAnimations.css';

export default function MiniGryphonSvg({ size = 120, color, className = '' }) {
  const lion = color || '#B97A38';
  const lionLight = '#DDA266';
  const lionDark = '#7A4C1C';
  const eagle = '#F4E3B8';
  const eagleShade = '#D6BE83';
  const beak = '#E8A53C';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Tail with tuft */}
      <path
        d="M88 78C100 76 108 66 104 56C102 50 96 54 96 60C96 68 92 74 86 78"
        stroke={lion}
        strokeWidth="5"
        strokeLinecap="round"
        fill="none"
      />
      <ellipse cx="106" cy="56" rx="4" ry="5" fill={lionDark} />
      {/* Lion body */}
      <ellipse cx="60" cy="74" rx="26" ry="20" fill={lion} />
      <ellipse cx="60" cy="80" rx="14" ry="10" fill={lionLight} opacity="0.5" />
      {/* Back legs (lion) */}
      <rect x="36" y="84" width="11" height="16" rx="4" fill={lion} />
      <rect x="73" y="84" width="11" height="16" rx="4" fill={lion} />
      <ellipse cx="41.5" cy="102" rx="6" ry="3" fill={lionDark} />
      <ellipse cx="78.5" cy="102" rx="6" ry="3" fill={lionDark} />
      {/* Front legs (eagle talons) */}
      <rect x="46" y="84" width="9" height="16" rx="3" fill={eagle} />
      <rect x="65" y="84" width="9" height="16" rx="3" fill={eagle} />
      <path d="M46 100L46 104M50 100L50 104M54 100L54 104" stroke={beak} strokeWidth="1.4" strokeLinecap="round" />
      <path d="M65 100L65 104M69 100L69 104M73 100L73 104" stroke={beak} strokeWidth="1.4" strokeLinecap="round" />
      {/* Wing */}
      <path d="M76 58C90 50 100 38 92 30C84 28 78 38 76 50Z" fill={eagle} />
      <path d="M78 58C88 52 96 42 90 36C84 36 80 44 78 52Z" fill={eagleShade} />
      <path d="M82 38C86 38 90 36 92 32" stroke={eagleShade} strokeWidth="1" fill="none" />
      <path d="M80 46C84 46 88 44 90 40" stroke={eagleShade} strokeWidth="1" fill="none" />
      {/* Eagle head */}
      <ellipse cx="48" cy="48" rx="16" ry="14" fill={eagle} />
      {/* Head feathers */}
      <path d="M36 42L30 32L42 38Z" fill={eagle} />
      <path d="M44 38L42 26L48 36Z" fill={eagleShade} />
      {/* Eye */}
      <circle cx="50" cy="46" r="3.5" fill="white" />
      <circle cx="51" cy="46.5" r="2.2" fill="#2C2419" />
      <circle cx="51.5" cy="45.5" r="0.7" fill="white" />
      {/* Beak */}
      <path d="M40 50L30 52L40 56C38 54 38 52 40 50Z" fill={beak} />
      <path d="M32 52L36 53" stroke={lionDark} strokeWidth="0.5" />
      {/* Mane (where lion meets eagle) */}
      <path d="M58 56C64 50 70 50 74 56C72 64 64 64 58 60Z" fill={lionDark} />
      <path d="M60 58C66 54 70 54 72 58" stroke={lion} strokeWidth="0.8" fill="none" />
    </svg>
  );
}
